/* Croia Glass Collection Toggle (Global / Multi-block Safe) */
(function () {
  if (window.__cgCollectionToggleBound) return;
  window.__cgCollectionToggleBound = true;

  function isHidden(el) {
    return window.getComputedStyle(el).display === 'none';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cg-toggle');
    if (!btn) return;

    var block = btn.closest('.cg-collection-block');
    if (!block) return;

    var full = block.querySelector('.cg-full');
    if (!full) return;

    e.preventDefault();
    e.stopPropagation();

    if (isHidden(full)) {
      full.style.display = 'block';
      btn.textContent = 'View Less';
      btn.setAttribute('aria-expanded', 'true');
    } else {
      full.style.display = 'none';
      btn.textContent = 'View More';
      btn.setAttribute('aria-expanded', 'false');

      var rect = block.getBoundingClientRect();
      var scrollTarget = window.pageYOffset + rect.top - 20;
      window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
    }
  }, true);
})();
